const K5A_ENDPOINT = 'https://cl.k5a.io';
const K5A_INSTALLATION_ID = '60ae49163984713a036f5c02';
const K5A_LIST_IMAGE = 'https://www.kommunal-rapport.no/files/2026/05/22/kb_k5a_icon.png';
var TrackerEvent;
(function (TrackerEvent) {
    TrackerEvent[TrackerEvent["fileDownload"] = 0] = "fileDownload";
    TrackerEvent[TrackerEvent["pageView"] = 1] = "pageView";
})(TrackerEvent || (TrackerEvent = {}));
;
let kDict = null;
fetch('https://api.munimeta.stage.kommunal-rapport.red/kb/kommuner')
    .then(r => r.json())
    .then(j => kDict = j.data);
const track = (type, path, params) => {
    var _a, _b, _c;
    const notToBeTracked = ['', 'hjem', 'login', 'logout'];
    const key = path.replace('#', '');
    const knr = (_b = (_a = key.match(/^kommuner\/(\d{4})(?:\/|$)/)) === null || _a === void 0 ? void 0 : _a[1]) !== null && _b !== void 0 ? _b : null;
    const mun = (knr !== null && kDict) ? ((_c = kDict[knr]) !== null && _c !== void 0 ? _c : null) : null;
    const sub = mun ? `${mun.kommune_knr} ${mun.kommune_navn}` : '-';
    if (window.kilkaya && !notToBeTracked.includes(key)) {
        let url = window.location.href.split('#')[0];
        const k5aMetaObject = {};
        if (type == TrackerEvent.fileDownload) {
            k5aMetaObject.type = 'fil';
            k5aMetaObject.cntTag = ['filnedlasting'];
            k5aMetaObject.tag = ['kb', 'filnedlasting'];
            if (params.docType) {
                k5aMetaObject.type = params.docType;
            }
            //trackerUrl.searchParams.set( 'ptp', params.docType ?? '-' );
            //trackerUrl.searchParams.set( 'pctg', 'filnedlasting' );
            //trackerUrl.searchParams.set( 'ptg', `kb|filnedlasting` );
        }
        else {
            k5aMetaObject.type = 'underside';
            if (/^totalrangering/.test(key)) {
                k5aMetaObject.cntTag = ['totalt', 'rangering'];
                k5aMetaObject.tag = ['kb', 'rangering'];
            }
            if (/^(hjem)?$/.test(key)) {
                k5aMetaObject.cntTag = ['totalt', 'landingsside'];
                k5aMetaObject.tag = ['kb', 'landingsside'];
            }
            if (/^kommuner\/(\d{4})\/?$/.test(key)) {
                k5aMetaObject.cntTag = ['totalt', 'kommuneforside'];
                k5aMetaObject.tag = ['kb', 'kommuneforside'];
            }
            if (/^kommuner\/(\d{4})\/sektorer\/[a-z]{2,3}\/?$/.test(key)) {
                k5aMetaObject.cntTag = ['totalt', 'sektorforside'];
                k5aMetaObject.tag = ['kb', 'sektorforside'];
            }
            if (/^kommuner\/(\d{4})\/filarkiv\/?$/.test(key)) {
                k5aMetaObject.cntTag = ['totalt', 'filarkiv'];
                k5aMetaObject.tag = ['kb', 'filarkiv'];
            }
        }
        k5aMetaObject.title = 'kb-labfront';
        k5aMetaObject.url = url;
        k5aMetaObject.referer = window.location.hostname;
        k5aMetaObject.image = K5A_LIST_IMAGE;
        k5aMetaObject.section = 'kb-labfront';
        k5aMetaObject.subSection = sub;
        k5aMetaObject.publishTime = '2026-05-01T00:00:00.000Z';
        window.kilkaya.pageview(k5aMetaObject);
    }
};
const createSessionId = () => Array.from({ length: 24 }, () => "abcdefghijklmnopqrstuvwxyz0123456789"[Math.floor(Math.random() * 36)]).join("");
export const K5A = {
    init: () => {
        const ogImgMetaTag = document.querySelector('meta[property="og:image"]');
        if (ogImgMetaTag) {
            ogImgMetaTag.setAttribute('content', K5A_LIST_IMAGE);
        }
        window.k5aMeta = { disablePageview: true };
    },
    download: (path, params = {}) => {
        track(TrackerEvent.fileDownload, path, params);
    },
    pageview: (path, params = {}) => {
        track(TrackerEvent.pageView, path, params);
    }
};
